export const SITE_NAME = 'Rama Dharma Prachara Sabha';
export const ROUTES = {
    HOME: "/",
    EVENTS: "/events",
    GALLERY: "/gallery",
    BOARD: '/boardmembers',
    KARKIDAKAVAVUBALI: '/karkidakavavubali',
    KARKIDAKAVAVUBALI_2026: '/karkidakavavubali-2026',
    BHAGAVATHA_SAPTAH: '/bhagavatha-saptah',
    PRIVACYPOLICY: '/privacypolicy',
    CHARITY: '/charity',
    INSTRUCTIONS: '/instructions'
};